<template>
  <div class="tab-container">
    <OverlayLoading
      :absoluteFlg="true"
      v-if="isLoading||!partsPrice"/>
    <BillingHeader
      :user="user"
    />
    <!-- 請求書ビュー -->
    <template v-if="!$route.query.view">
      <BillingView
        :user="user"
        :animated="animated"
        :year="year"
        :month="month"
        :masterBilling="masterBilling"
        :billingData="billingData"
        :partsPrice="partsPrice"
        :payperuseInfoData="payperuseInfoData"
        @setProfile="setProfile"
        @nextMonth="nextMonth"
        @prevMonth="prevMonth"
        @updatePartsPrice="updatePartsPrice"
        v-if="masterBilling && partsPrice"
      />
    <!-- プラン選択ビュー -->
    </template>
    <template v-else>
      <PlanView
        :user="user"
        :masterBilling="masterBilling"
        @setProfile="setProfile"
        @planNotify="sendEmail"
        v-if="masterBilling"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import OverlayLoading from '@/components/animations/OverlayLoading'
import BillingHeader from '@/views/DashBoard/Setting/Billing/BillingHeader'
import BillingView from '@/views/DashBoard/Setting/Billing/BillingView'
import PlanView from '@/views/DashBoard/Setting/Billing/PlanView'

export default {
  components: {
    OverlayLoading,
    BillingHeader,
    BillingView,
    PlanView
  },
  data () {
    return {
      animated: true,
      billingData: [],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      isLoading: false
    }
  },
  computed: {
    ...mapState('auth', ['user', 'success', 'error', 'payperuseInfoData']),
    ...mapState('master', ['partsPrice', 'masterBilling']),
  },
  watch: {
    error () {
      this.$buefy.snackbar.open({
        message: 'エラーが発生いたしました。当月にプラン変更した場合は翌月にプラン変更をお願いいたします。',
        type: 'is-danger',
        position: 'is-top'
      })
    },
    success () {
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
    }
  },
  created () {
    this.isLoading = true
    this.$store.dispatch('master/getBilling', null)
    this.$store.dispatch('directtalk/getBiilingData',
      {
        year  : this.year,
        month : this.month,
      }
    )
      .then((d) => {
        this.isLoading = false
        this.billingData = d
      })
    this.$store.dispatch('master/getPartsPrice', null)
  },
  methods: {
    nextMonth () {
      if (this.month == 12) {
        this.year ++
        this.month = 1
      } else {
        this.month ++
      }
      this.billingData = []
      this.isLoading = true
      this.$store.dispatch('directtalk/getBiilingData',
        {
          year  : this.year,
          month : this.month,
        }
      )
        .then((d) => {
          this.isLoading = false
          this.billingData = d
        })
    },
    prevMonth () {
      if (this.month == 1) {
        this.year --
        this.month = 12
      } else {
        this.month --
      }
      this.billingData = []
      this.isLoading = true
      this.$store.dispatch('directtalk/getBiilingData',
        {
          year  : this.year,
          month : this.month,
        }
      )
        .then((d) => {
          this.isLoading = false
          this.billingData = d
        })
    },
    updatePartsPrice (parts) {
      this.$store.dispatch('master/updatePartsPrice', parts)
    },
    setProfile (data) {
      this.$store.dispatch('auth/setProfile', {data: data, type: 'company'})
    },
    sendEmail (data) {
      this.$store.dispatch('master/sendEmail', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-container {
  padding: 8px;
  overflow: auto;
  height: 100%;
  text-align: left;
  position: relative;
}
.tab-box {
  padding: 16px;
}
/deep/ .tabs > ul {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Setting/Billing/BillingSetting.vue